import _classCallCheck from "/Users/xenon/work/vital/vitalwebsite/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/xenon/work/vital/vitalwebsite/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/xenon/work/vital/vitalwebsite/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/xenon/work/vital/vitalwebsite/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/xenon/work/vital/vitalwebsite/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Base } from './Base.js';
import * as utils from './utils.js';
export var Struct = /*#__PURE__*/function (_Base) {
  _inherits(Struct, _Base);
  function Struct() {
    var _this;
    var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Struct);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Struct).call(this));
    _this.fields = fields;
    return _this;
  }
  _createClass(Struct, [{
    key: "decode",
    value: function decode(stream, parent) {
      var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var res = this._setup(stream, parent, length);
      this._parseFields(stream, res, this.fields);
      if (this.process != null) {
        this.process.call(res, stream);
      }
      return res;
    }
  }, {
    key: "_setup",
    value: function _setup(stream, parent, length) {
      var res = {};

      // define hidden properties
      Object.defineProperties(res, {
        parent: {
          value: parent
        },
        _startOffset: {
          value: stream.pos
        },
        _currentOffset: {
          value: 0,
          writable: true
        },
        _length: {
          value: length
        }
      });
      return res;
    }
  }, {
    key: "_parseFields",
    value: function _parseFields(stream, res, fields) {
      for (var key in fields) {
        var val;
        var type = fields[key];
        if (typeof type === 'function') {
          val = type.call(res, res);
        } else {
          val = type.decode(stream, res);
        }
        if (val !== undefined) {
          if (val instanceof utils.PropertyDescriptor) {
            Object.defineProperty(res, key, val);
          } else {
            res[key] = val;
          }
        }
        res._currentOffset = stream.pos - res._startOffset;
      }
    }
  }, {
    key: "size",
    value: function size(val, parent) {
      var includePointers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (val == null) {
        val = {};
      }
      var ctx = {
        parent: parent,
        val: val,
        pointerSize: 0
      };
      if (this.preEncode != null) {
        this.preEncode.call(val);
      }
      var size = 0;
      for (var key in this.fields) {
        var type = this.fields[key];
        if (type.size != null) {
          size += type.size(val[key], ctx);
        }
      }
      if (includePointers) {
        size += ctx.pointerSize;
      }
      return size;
    }
  }, {
    key: "encode",
    value: function encode(stream, val, parent) {
      var type;
      if (this.preEncode != null) {
        this.preEncode.call(val, stream);
      }
      var ctx = {
        pointers: [],
        startOffset: stream.pos,
        parent: parent,
        val: val,
        pointerSize: 0
      };
      ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
      for (var key in this.fields) {
        type = this.fields[key];
        if (type.encode != null) {
          type.encode(stream, val[key], ctx);
        }
      }
      var i = 0;
      while (i < ctx.pointers.length) {
        var ptr = ctx.pointers[i++];
        ptr.type.encode(stream, ptr.val, ptr.parent);
      }
    }
  }]);
  return Struct;
}(Base);